import script from "./headerPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./headerPhone.vue?vue&type=script&setup=true&lang=js"

import "./headerPhone.vue?vue&type=style&index=0&id=e3015a82&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3015a82"]])

export default __exports__